import { Box, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function RAPDChartLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography fontWeight="bold">{t("word_legend")}</Typography>
      <Grid container display="flex" rowSpacing={1} columnSpacing={2}>
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing={1}
          columnSpacing={2}
        >
          <Grid item display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "red",
              }}
            ></div>
            <Typography variant="body2" fontSize="12px">
              {t("left_eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "blue",
              }}
            ></div>
            <Typography variant="body2" fontSize="12px">
              {t("right_eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap={1}>
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "green",
                opacity: 0.4,
              }}
            ></div>
            <Typography variant="body2" fontSize="12px">
              {t("blink")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
